var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html } from 'lit';
import tinycolor from 'tinycolor2';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './badge.styles.js';
import { when } from 'lit/directives/when.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
/**
 * @summary Badge
 * @status experimental
 * @since 1.0
 *
 * @dependency sgdf-icon-button
 *
 * @event sgdf-delete - Emitted when delete button is clicked.
 */
class SgdfBadge extends SgdfElement {
    constructor() {
        super(...arguments);
        this.removable = false;
        this.color = '#00395c';
        this.small = false;
        this.clickable = false;
        // Property to track if the icon slot has content
        this.hasIconContent = false;
    }
    firstUpdated() {
        var _a;
        // Get reference to the icon slot
        this.iconSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="icon"]');
        if (this.iconSlot) {
            // Check if the slot has any assigned nodes
            this.updateIconStatus();
            // Watch for changes in slot content
            this.iconSlot.addEventListener('slotchange', () => this.updateIconStatus());
        }
    }
    updateIconStatus() {
        if (this.iconSlot) {
            const assignedNodes = this.iconSlot.assignedNodes();
            this.hasIconContent = assignedNodes.length > 0;
            this.requestUpdate(); // Trigger re-render when icon status changes
        }
    }
    render() {
        var _a, _b;
        return html `<div
            class=${classMap({
            container: true,
            removable: this.removable,
            small: this.small,
            medium: !this.small,
            clickable: this.clickable,
            'has-icon': this.hasIconContent
        })}
            style=${styleMap({
            '--item-bg-color': this.color,
            '--item-bg-color-hover': (_a = this.colorHovered) !== null && _a !== void 0 ? _a : tinycolor(this.color)
                .darken(5)
                .toHexString(),
            '--item-color': (_b = this.textColor) !== null && _b !== void 0 ? _b : tinycolor
                .mostReadable(this.color, [
                '#000',
                '#777',
                '#bbb',
                '#fff',
            ])
                .toHexString(),
        })}
        >
            <div class="icon" ?hidden="${!this.hasIconContent}">
                <slot name="icon"></slot>
            </div>
            <slot></slot>
            ${when(this.removable, () => html `
                    <sgdf-icon-button
                        @click=${() => this.emit('sgdf-delete')}
                        name="pen"
                        style=${styleMap({
            '--icon-color': tinycolor
                .mostReadable(this.color, [
                '#000',
                '#777',
                '#bbb',
                '#fff',
            ])
                .toHexString(),
        })}
                    ></sgdf-icon-button>
                `)}
        </div>`;
    }
}
SgdfBadge.styles = styles;
export default SgdfBadge;
__decorate([
    property({ type: Boolean })
], SgdfBadge.prototype, "removable", void 0);
__decorate([
    property({ type: String })
], SgdfBadge.prototype, "color", void 0);
__decorate([
    property({ type: Boolean })
], SgdfBadge.prototype, "small", void 0);
__decorate([
    property({ type: String })
], SgdfBadge.prototype, "textColor", void 0);
__decorate([
    property({ type: String })
], SgdfBadge.prototype, "colorHovered", void 0);
__decorate([
    property({ type: Boolean })
], SgdfBadge.prototype, "clickable", void 0);
//# sourceMappingURL=badge.component.js.map